import { css } from 'linaria';

export const productServicesContainer = css`
  padding: 14px 0 12px 0;
`;

export const productInfoServicesTitle = css`
  margin-bottom: 12px;
`;

export const productInfoServicesContainer = css`
  display: flex;
  column-gap: 12px;
  margin-bottom: 8px;
`;

export const productInfoServiceWrapper = css`
  && {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 12px;
    row-gap: 16px;
    background-color: #d3f0f3;
    border-radius: var(--rounding-l);
  }
`;

export const productInfoServicePriceWrapper = css`
  padding: 10px 20px;
  margin-left: auto;
  background-color: var(--background-primary);
  border-radius: var(--rounding-l);
  width: 100%;

  @media (--only-mobile) {
    padding: 6px 12px;
  }
`;
